import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import Moment from 'react-moment';

class LocationDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activity_data: {},
      location: '',
      date: '',
    };
  }

  getCurrentDate(date) {
    let newDate = new Date(date);

    let day = newDate.getUTCDate();
    let month = newDate.getUTCMonth() + 1;
    let year = newDate.getUTCFullYear();

    let hour = newDate.getUTCHours();
    let minute = newDate.getUTCMinutes();

    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;

    if (hour < 10) hour = '0' + hour;
    if (minute < 10) minute = '0' + minute;

    return year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
  }

  componentDidMount() {
    if (
      this.props.data.activityId !== null ||
      this.props.data.activityId !== ''
    ) {
      let id = this.props.data.activityId;
      const act = this.props.data.activityList.find(
        e => e.activity_data_id === id,
      );

      this.setState({
        activity_data: JSON.parse(act.activity_data),
        location: act.name,
        date: act.localdt,
      });
    }
  }

  render() {
    const { activity_data, location, date } = this.state;
    return (
      <>
        <ModalHeader toggle={this.props.onToggleModal()}>
          Location Information
        </ModalHeader>
        <ModalBody className="ps-modal-display">
          <Row>
            <Col md={6}>
              <Label>Location</Label>
              <p>{location}</p>
            </Col>
            <Col md={6}>
              <Label>Date</Label>
              <p>
                {this.getCurrentDate(date)}
                {/* <Moment format="YYYY-MM-DD HH:mm">{date}</Moment> */}
              </p>
            </Col>
            {Object.keys(activity_data).map(function (key, index) {
              return (
                <Col md={6} key={index}>
                  <Label>{key[0].toUpperCase() + key.slice(1)}</Label>
                  <p>
                    {activity_data[key] === null ? 'No' : activity_data[key]}
                  </p>
                </Col>
              );
            })}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
        </ModalFooter>
      </>
    );
  }
}

export default LocationDetails;
